import { ArrowForwardIcon } from '@chakra-ui/icons';
import {
  Alert,
  AlertIcon,
  AlertStatus,
  Box,
  Button,
  Container,
  Flex,
  Grid,
  GridItem,
  Heading,
  HStack,
  Icon,
  Image,
  Input,
  InputGroup,
  InputRightAddon,
  Link,
  SimpleGrid,
  Spinner,
  Text,
  Tooltip,
  useDisclosure,
  useToast,
  VStack,
  WrapItem
} from '@chakra-ui/react';
import { Global } from '@emotion/react';
import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import QRCode from 'react-qr-code';
import { useNavigate } from 'react-router-dom';

import imageDefaultWebsite from '../../../assets/assessoria/backgroundLogin.png';
import { CopyPasteIcon } from '../../../assets/icons/CopyPasteIcon';
import { DownwardArrowIcon } from '../../../assets/icons/DownwardArrowIcon';
import { FacebookIcon } from '../../../assets/icons/FacebookIcon';
import { LinkedinIcon } from '../../../assets/icons/LinkedinIcon';
import { PencilIcon } from '../../../assets/icons/PencilIcon';
import { PlayIcon } from '../../../assets/icons/PlayIcon';
import { QRCodeIcon } from '../../../assets/icons/QRCodeIcon';
import { SadFaceIcon } from '../../../assets/icons/SadFaceIcon';
import { TrashIcon } from '../../../assets/icons/TrashIcon';
import { TwitterIcon } from '../../../assets/icons/TwitterIcon';
import { WhatsAppIcon } from '../../../assets/icons/WhatsAppIcon';
import { WhiteEyeIcon } from '../../../assets/icons/WhiteEyeIcon';
import { WhitePencilIcon } from '../../../assets/icons/WhitePencilIcon';
import { WhiteLabelMenu } from '../../../components/navigation/WhiteLabelMenu';
import { ModalConfirm } from '../../../components/white-label/modals/ModalConfirm';
import { useStepsForm } from '../../../hooks/useStepsForm';
import { apiSensedia } from '../../../services/api-sensedia';
import { getDominio } from '../../../services/white-label/dominio.service';
import { WarningTextBox } from '../previdencia-individual/movimentacao-fundos/components/WarningTextBox';
import type { WebsitesPaginated } from './websites-paginated';

let apiWl = apiSensedia;

if (process.env.NODE_ENV != 'development') {
  apiWl = apiSensedia;
}

const LIMIT = 50;

export const PainelWhiteLabel = (): JSX.Element => {
  const navigate = useNavigate();
  const { state } = useStepsForm();
  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [typeAction, setTypeAction] = useState({
    type: '',
    id: ''
  });

  const [websitesArrived, setWebsitesArrived] = useState(false);
  const [websitesCount, setWebsitesCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [error, setError] = useState<
    { variant: AlertStatus; message: string } | undefined
  >();

  const [dataWebsites, setDataWebsites] = useState([
    {
      codigo: '',
      website_subdomain: '',
      website_title: '',
      codigo_corretor: '',
      website_color: '',
      buttons_color: '',
      website_logo: '',
      website_logo_url: '',
      name_logo: '',
      contains_sulamerica_logo: false,
      whatsapp: '',
      banner_first_sec: '',
      banner_first_sec_url: '',
      description_first_sec_title: '',
      description_first_sec_subtitle: '',
      banner_second_sec: '',
      banner_second_sec_url: '',
      description_second_sec_title: '',
      description_second_sec_subtitle: '',
      corretagem: '',
      periodicidade: '',
      agenciamento: '',
      facebook: '',
      instagram: '',
      twitter: '',
      youtube: '',
      email: '',
      status: '',
      status_history: [{ status: '', date: '' }],
      thumb: '',
      publishDate: '',
      has_criticized_in_review: false,
      has_version_in_review: false
    }
  ]);

  const getWebsites = async (page = 0) => {
    const offset = page * LIMIT;

    setError(undefined);

    try {
      const res = await apiWl.get<WebsitesPaginated>(
        '/corretores/123/websites',
        {
          params: {
            _limit: LIMIT,
            _offset: offset
          }
        }
      );
      const pages = res.data._embedded._links_page;
      const result = res.data._embedded._result;
      setHasNextPage(!!pages.find(({ page }) => page === 'next'));
      if (websitesArrived) {
        setDataWebsites((prev) => [...prev, ...result]);
      } else {
        setDataWebsites(result);
      }
      setWebsitesArrived(true);
      setWebsitesCount(res.data._embedded._count);
    } catch (error: any) {
      setWebsitesArrived(false);
      console.log(error);

      if (
        error.response &&
        error.response.data.message === 'unauthorized:notincluded'
      ) {
        setError({
          variant: 'info',
          message:
            'Esta funcionalidade é mais uma novidade que estamos preparando para você, aguarde o lançamento oficial em breve.'
        });
        return;
      }

      setError({
        variant: 'error',
        message: 'Desculpe, não foi possível carregar os sites'
      });
    }
  };

  console.log('carregou o painel');

  const handlePostWebsite = async () => {
    try {
      const body = {};

      const res = await apiWl.post(`/websites`);

      navigate(`../step-one/${res.data.codigo}`, {
        state: { codigo_corretor: res.data.codigo_corretor }
      });
      //window.location.href = `step-one/${res.data.codigo}`;
    } catch (error) {
      console.log(error);
    }
  };

  const handlePutWebsite = async (id: string) => {
    try {
      const res = await apiWl.get(`/websites/${id}`);
      window.location.href = `step-one/${res.data.codigo}`;
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteWebsite = async (id: string) => {
    try {
      await apiWl.delete(`/websites/${id}`);

      location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  const handleDashboard = (idWebsite: string) => {
    navigate(`/corretor/white-label/painel-vendas/${idWebsite}`);
  };

  const handlePreviewButton = async (codigo: string) => {
    const headers = {
      id_site: codigo as string
    };
    const axiosConfig = {
      headers: { ...headers }
    };

    try {
      let response = undefined;
      if (process.env.NODE_ENV === 'development') {
        const url = `${process.env.REACT_APP_WS_WHITELABEL_HOST}/websites/endereco-assinado`;
        response = await axios.post(url, {}, axiosConfig);
      } else {
        response = await apiWl.post(
          '/websites/endereco-assinado',
          {},
          {
            headers: { ...headers }
          }
        );
      }

      if (response.data.url) {
        const url = response.data.url;
        window.open(url, '_blank');
      } else {
        toast({
          description: 'Não foi possível abrir o preview neste momento.',
          status: 'error'
        });
      }
    } catch (error) {
      console.log(error);
      toast({
        description: 'Não foi possível abrir o preview neste momento.',
        status: 'error'
      });
    }
  };

  const handleGenerateQrCode = useCallback((data: string) => {
    const mywindow = window.open('', 'PRINT', 'height=600,width=800');
    if (mywindow) {
      mywindow.document.write(`
      <html>
        <head>
        <style>
          body {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            padding-top: 50px;
            margin: 0 auto;
          }
        </style>
        <title> QRCode </title>
    `);
      mywindow.document.write('</head><body ><div id="qrcode_root></div>');
      mywindow.document.write('</body></html>');

      ReactDOM.render(
        <QRCode value={data} size={400} />,
        mywindow.document.body as any
      );

      // mywindow?.document.close(); // necessary for IE >= 10
      // mywindow?.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();
    }
  }, []);

  useEffect(() => {
    getWebsites(currentPage);
    // const tokenPortal = searchParams.get('token');
    // tokenPortal && localStorage.setItem('tokenPortal', tokenPortal);
    // location.pathname === '/' && checkUser();
  }, [currentPage]);

  if (!websitesArrived) {
    return (
      <Box
        w="100%"
        h="100vh"
        pt={10}
        display="flex"
        flexDirection="column"
        alignItems={'center'}
        justifyContent={error ? 'flex-start' : 'center'}
        gridGap="15px"
      >
        <Container>
          {!error ? (
            <>
              <Box display="flex" flexDirection="column" alignItems={'center'}>
                <Spinner
                  thickness="6px"
                  speed="0.65s"
                  emptyColor="#FF5000"
                  color="#FFFFFF"
                  size="xl"
                />
                <Text>Carregando...</Text>
              </Box>
            </>
          ) : (
            <Alert status={error.variant}>
              <AlertIcon />
              {error.message}
            </Alert>
          )}
        </Container>
      </Box>
    );
  }

  return (
    <>
      <Global styles={`body { background-color: #F4F4F4; }`} />
      <Grid templateColumns="15vw calc( 80vw - 17px )">
        <GridItem>
          <WhiteLabelMenu />
        </GridItem>
        <GridItem>
          <Box p="40px 56px">
            <VStack pb="40px" spacing="40px" borderBottom="1px solid #D2D2D2">
              <HStack
                width="100%"
                justifyContent="space-between"
                alignItems="start"
              >
                <VStack alignItems="start">
                  <Heading fontSize="2rem">Vamos criar o seu site?</Heading>
                  <Text fontSize="1rem">É simples, fácil e rápido.</Text>
                </VStack>
              </HStack>
              <VStack width="100%" alignItems="start">
                <Heading fontSize="1.25rem">Sites publicados</Heading>
                <Text fontSize="1rem" color="#001E64">
                  Quantidade de sites publicados: {websitesCount}
                </Text>
                <WarningTextBox
                  content="Atenção: O Produto Vida Individual será substituido pelo novo produto Vida Flex! A partir de 02/04, você terá 30 dias para atualizar seus links criados. Não deixe para última hora, atualize agora mesmo!"
                  full={true}
                />
              </VStack>
            </VStack>

            <SimpleGrid
              columns={3}
              minChildWidth="350px"
              pt="40px"
              spacingX="24px"
              spacingY="30px"
            >
              {dataWebsites.map((item, index) => {
                const website = item;
                return (
                  <Box
                    key={index}
                    as="div"
                    minH="500px"
                    w="350px"
                    h="1vh"
                    bg="white"
                    boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
                    borderRadius="24px"
                    pb="28px"
                  >
                    <VStack height="100%">
                      <Box
                        w="100%"
                        borderRadius="24px 24px 0 0"
                        overflow="hidden"
                        maxHeight="182px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        position="relative"
                      >
                        <Box
                          as="span"
                          bg={
                            website.status === 'P'
                              ? '#FF5000'
                              : website.status === 'EE'
                              ? '#146CFA'
                              : website.status === 'EA'
                              ? '#E59401'
                              : website.status === 'C'
                              ? '#AA2C23'
                              : '#001E64'
                          }
                          color="white"
                          p="2px 9px"
                          borderRadius="7.5px"
                          fontSize="0.87rem"
                          position="absolute"
                          right="20px"
                          top="20px"
                          zIndex="2"
                        >
                          {website.status === 'P'
                            ? 'Publicado'
                            : website.status === 'EA'
                            ? 'Em análise'
                            : website.status === 'EE'
                            ? 'Em edição'
                            : website.status === 'C'
                            ? 'Criticado'
                            : ''}
                        </Box>

                        <Box
                          w="100%"
                          h="100%"
                          position="absolute"
                          zIndex="2"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          flexDirection="column"
                        >
                          <Button
                            _hover={{}}
                            bg="transparent"
                            onClick={() => handlePreviewButton(website.codigo)}
                          >
                            <PlayIcon w="2.18rem" h="2.18rem" />
                          </Button>
                          <Text color="white" fontSize="0.75rem">
                            Apresentação da página
                          </Text>
                        </Box>
                        <Box
                          w="100%"
                          h="100%"
                          bg="black"
                          opacity="0.5"
                          position="absolute"
                          zIndex="1"
                          display="flex"
                        ></Box>
                        <Image
                          zIndex="0"
                          w="100%"
                          h="182px"
                          src={
                            !website.banner_first_sec_url
                              ? imageDefaultWebsite
                              : website.banner_first_sec_url
                          }
                        />
                      </Box>
                      <Box
                        width="100%"
                        p="0 20px"
                        borderBottom="1px solid #F4F4F4"
                        pb="20px"
                        mt="0 !important"
                      >
                        <VStack w="100%">
                          <HStack
                            justifyContent="space-between"
                            pt="20px"
                            w="100%"
                          >
                            <Box>
                              <Heading fontSize="1.25rem">
                                {website.website_title}
                              </Heading>

                              <Text fontSize="0.87rem" color="#323232">
                                {website.status == 'EE'
                                  ? 'Continue editando seu site'
                                  : ''}
                                {website.status == 'C' ? 'Com pendências' : ''}
                                {website.status != 'EE' && website.status != 'C'
                                  ? website.status_history.map((item) => {
                                      let statusNameAndDate = '';
                                      if (item.status == 'P') {
                                        statusNameAndDate = `- Publicado: ${item.date}`;
                                      }
                                      if (
                                        item.status == 'EA' &&
                                        website.status == 'P'
                                      ) {
                                        statusNameAndDate = `- Suas edições serão analisadas com prazo de 2 dias úteis após:  ${item.date}`;
                                      } else if (item.status == 'EA') {
                                        statusNameAndDate = `- 2 dias úteis em análise após: ${item.date}`;
                                      }
                                      if (item.status == 'EE') {
                                        statusNameAndDate = `- Em edição: ${item.date}`;
                                      }
                                      if (item.status == 'C') {
                                        statusNameAndDate = `- Criticado em: ${item.date}`;
                                      }
                                      return (
                                        <>
                                          {statusNameAndDate} <br />
                                        </>
                                      );
                                    })
                                  : ''}
                              </Text>
                            </Box>
                            <HStack
                              gap="10px"
                              alignItems="end"
                              color="#828282"
                              fontSize="0.75rem"
                              filter={
                                website.status == 'EA' ||
                                website.has_version_in_review
                                  ? 'grayscale(1)'
                                  : 'none'
                              }
                            >
                              <Link
                                href="#"
                                onClick={() => {
                                  setTypeAction({
                                    type: 'update',
                                    id: website.codigo
                                  });
                                  onOpen();
                                }}
                                _hover={{}}
                                _focus={{
                                  '&:focus': {
                                    boxShadow: 'none !important'
                                  }
                                }}
                                _active={{}}
                                pointerEvents={
                                  website.status == 'EA' ||
                                  website.has_version_in_review
                                    ? 'none'
                                    : 'all'
                                }
                              >
                                <VStack>
                                  <PencilIcon w="1.5rem" h="1.5rem" />
                                  <Text>Alterar</Text>
                                </VStack>
                              </Link>
                              <Link
                                href="#"
                                onClick={() => {
                                  setTypeAction({
                                    type: 'delete',
                                    id: website.codigo
                                  });
                                  onOpen();
                                }}
                                _hover={{}}
                                _focus={{
                                  '&:focus': {
                                    boxShadow: 'none !important'
                                  }
                                }}
                                _active={{}}
                                pointerEvents={
                                  website.status == 'EA' ||
                                  website.has_version_in_review
                                    ? 'none'
                                    : 'all'
                                }
                              >
                                <VStack>
                                  <TrashIcon w="2rem" h="2rem" />
                                  <Text>Excluir</Text>
                                </VStack>
                              </Link>
                            </HStack>
                          </HStack>
                          {/* <HStack
                            w="100%"
                            fontSize="0.87rem"
                            justifyContent="start"
                            color="white"
                            mt="5px !important"
                          >
                            <Link
                              href="#"
                              bg="#AAAAAA"
                              m="0 !important"
                              p="3px 7px"
                              borderRadius="7px 0 0 7px"
                            >
                              Desativar
                            </Link>
                            <Link
                              href="#"
                              bg="#001E64"
                              m="0 !important"
                              p="3px 7px"
                              borderRadius="0 7px 7px 0"
                            >
                              Ativo
                            </Link>
                          </HStack> */}
                        </VStack>
                      </Box>
                      <Box
                        w="100%"
                        p="0 20px"
                        pt="20px"
                        mt="0 !important"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100%"
                        maxHeight="191px"
                      >
                        {website.status == 'EE' ? (
                          <Link
                            // href="step-one"
                            bg="#FF5000"
                            p="13px 47px"
                            borderRadius="133.5px"
                            color="white"
                            fontSize="1rem"
                            m="0 !important"
                            width="100%"
                            textAlign="center"
                            h="fit-content"
                            onClick={() => {
                              setTypeAction({
                                type: 'update',
                                id: website.codigo
                              });
                              onOpen();
                            }}
                          >
                            <WhitePencilIcon w="1.5rem" h="1.5rem" mr="10px" />
                            Editar site
                          </Link>
                        ) : (
                          ''
                        )}
                        {website.status == 'C' ||
                        website.has_criticized_in_review ? (
                          <Link
                            // href="step-one"
                            bg="#FF5000"
                            p="13px 47px"
                            borderRadius="133.5px"
                            color="white"
                            fontSize="1rem"
                            m="0 !important"
                            width="100%"
                            textAlign="center"
                            h="fit-content"
                            onClick={() => {
                              handlePutWebsite(website.codigo);
                            }}
                          >
                            <WhiteEyeIcon w="1.5rem" h="1.5rem" mr="10px" />
                            Visualizar pendências
                          </Link>
                        ) : (
                          ''
                        )}
                        {website.status != 'EE' &&
                        website.status != 'C' &&
                        !website.has_criticized_in_review ? (
                          <VStack
                            w="100%"
                            alignItems="start"
                            pointerEvents={
                              website.status == 'EA' ? 'none' : 'all'
                            }
                            filter={
                              website.status == 'EA' ? 'grayscale(1)' : 'none'
                            }
                          >
                            <Link
                              m="22px 0"
                              bg="transparent"
                              // href="painel-vendas"
                              fontSize="0.875rem"
                              fontWeight="700"
                              lineHeight="1rem"
                              textDecoration="underline !important"
                              color="#146CFA"
                              onClick={() => {
                                handleDashboard(website.codigo);
                              }}
                              _hover={{}}
                              _active={{}}
                              _focus={{
                                '&:focus': {
                                  boxShadow: 'none !important'
                                }
                              }}
                            >
                              ACOMPANHAR VENDAS
                              <ArrowForwardIcon ml="8px" w="1rem" h="1rem" />
                            </Link>
                            <Text fontWeight="bold" fontSize="0.88rem">
                              Compartilhar o link é fácil e rápido!
                            </Text>
                            <InputGroup mt="0 !important">
                              <Input
                                type="text"
                                value={`https://${
                                  website.website_subdomain
                                }.${getDominio()}`}
                                borderRight="none"
                                disabled
                                _hover={{
                                  borderColor: '#F3F6F9'
                                }}
                              />
                              <WrapItem>
                                <Tooltip label="Copiar">
                                  <InputRightAddon
                                    bg="white"
                                    cursor="pointer"
                                    borderColor="#F3F6F9"
                                    onClick={() =>
                                      navigator.clipboard.writeText(
                                        `https://${
                                          website.website_subdomain
                                        }.${getDominio()}`
                                      )
                                    }
                                  >
                                    <CopyPasteIcon />
                                  </InputRightAddon>
                                </Tooltip>
                              </WrapItem>
                            </InputGroup>
                            <HStack
                              justifyContent="center"
                              w="100%"
                              gap=".4rem"
                              m="20px 0px 30px 0px !important"
                            >
                              {/* {website.whatsapp && ( */}
                              <VStack textAlign="center">
                                <Link
                                  href={`https://api.whatsapp.com/send?text=https://${
                                    website.website_subdomain
                                  }.${getDominio()}?sourceRef=${btoa(
                                    'whatsapp'
                                  )}`}
                                  target="_blank"
                                  bg={'#1BD742'}
                                  w="2.5rem"
                                  h="2.5rem"
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  borderRadius="50%"
                                  _hover={{}}
                                  _active={{}}
                                  _focus={{
                                    '&:focus': {
                                      boxShadow: 'none !important'
                                    }
                                  }}
                                >
                                  <Icon fontSize="14px" as={WhatsAppIcon} />
                                </Link>
                                <Text fontSize=".6rem">{'Whatsapp'}</Text>
                              </VStack>
                              {/* )} */}
                              {/* {website.facebook && ( */}
                              <VStack textAlign="center">
                                <Link
                                  href={`https://www.facebook.com/sharer/sharer.php?u=https://${
                                    website.website_subdomain
                                  }.${getDominio()}?sourceRef=${btoa(
                                    'facebook'
                                  )}`}
                                  target="_blank"
                                  bg={'#485A96'}
                                  w="2.5rem"
                                  h="2.5rem"
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  borderRadius="50%"
                                  _hover={{}}
                                  _active={{}}
                                  _focus={{
                                    '&:focus': {
                                      boxShadow: 'none !important'
                                    }
                                  }}
                                >
                                  <Icon fontSize="14px" as={FacebookIcon} />
                                </Link>
                                <Text fontSize=".6rem">{'Facebook'}</Text>
                              </VStack>
                              {/* )} */}
                              {/* {website.twitter && ( */}
                              <VStack textAlign="center">
                                <Link
                                  href={`https://twitter.com/intent/tweet?text=https://${
                                    website.website_subdomain
                                  }.${getDominio()}?sourceRef=${btoa(
                                    'twitter'
                                  )}`}
                                  target="_blank"
                                  bg={'#1D9BF0'}
                                  w="2.5rem"
                                  h="2.5rem"
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  borderRadius="50%"
                                  _hover={{}}
                                  _active={{}}
                                  _focus={{
                                    '&:focus': {
                                      boxShadow: 'none !important'
                                    }
                                  }}
                                >
                                  <Icon fontSize="14px" as={TwitterIcon} />
                                </Link>
                                <Text fontSize=".6rem">{'Twitter'}</Text>
                              </VStack>
                              <VStack textAlign="center">
                                <Link
                                  href={`https://www.linkedin.com/shareArticle?mini=true&url=https://${
                                    website.website_subdomain
                                  }.${getDominio()}?sourceRef=${btoa(
                                    'linkedin'
                                  )}`}
                                  target="_blank"
                                  bg={'#0A66C2'}
                                  w="2.5rem"
                                  h="2.5rem"
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  borderRadius="50%"
                                  _hover={{}}
                                  _active={{}}
                                  _focus={{
                                    '&:focus': {
                                      boxShadow: 'none !important'
                                    }
                                  }}
                                >
                                  <Icon fontSize="14px" as={LinkedinIcon} />
                                </Link>
                                <Text fontSize=".6rem">{'Linkedin'}</Text>
                              </VStack>

                              {/* )} */}
                              {/* {website.instagram && (
                                <VStack textAlign="center">
                                  <Link
                                    href={`https://${website.instagram}`}
                                    target="_blank"
                                    bg={
                                      'linear-gradient(206.3deg, #C7059A 11.66%, #DD0E44 123.55%)'
                                    }
                                    w="2.5rem"
                                    h="2.5rem"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    borderRadius="50%"
                                  >
                                    <Icon fontSize="14px" as={InstagramIcon} />
                                  </Link>
                                  <Text fontSize=".6rem">{'Instagram'}</Text>
                                </VStack>
                              )}
                              {website.youtube && (
                                <VStack textAlign="center">
                                  <Link
                                    href={`https://${website.youtube}`}
                                    target="_blank"
                                    bg={'#1D9BF0'}
                                    w="2.5rem"
                                    h="2.5rem"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    borderRadius="50%"
                                  >
                                    <Icon fontSize="14px" as={YoutubeIcon} />
                                  </Link>
                                  <Text fontSize=".6rem">{'YouTube'}</Text>
                                </VStack>
                              )} */}
                              {website.status === 'P' ? (
                                <VStack textAlign="center">
                                  <Button
                                    onClick={() =>
                                      handleGenerateQrCode(
                                        `https://${
                                          website.website_subdomain
                                        }.${getDominio()}?sourceRef=${btoa(
                                          'qrcode'
                                        )}`
                                      )
                                    }
                                    bg={'#F4F4F4'}
                                    w="2.5rem"
                                    h="2.5rem"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    borderRadius="50%"
                                  >
                                    <Icon fontSize="16px" as={QRCodeIcon} />
                                  </Button>
                                  <Text fontSize=".6rem">{'QRcode'}</Text>
                                </VStack>
                              ) : undefined}
                            </HStack>
                          </VStack>
                        ) : (
                          ''
                        )}
                      </Box>
                    </VStack>
                  </Box>
                );
              })}
              <Box
                as="div"
                minH="500px"
                w="350px"
                h="1vh"
                bg="white"
                boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
                borderRadius="24px"
                p="28px 20px"
              >
                <Grid gridTemplateRows="88% 12%" height="100%">
                  <VStack
                    alignItems="center"
                    justifyContent="center"
                    position="relative"
                  >
                    <Box
                      as="span"
                      bg="#001E64"
                      color="white"
                      p="2px 9px"
                      borderRadius="7.5px"
                      fontSize="0.87rem"
                      position="absolute"
                      right="0"
                      top="-8px"
                    >
                      Vazio
                    </Box>
                    <SadFaceIcon w="3.8rem" h="4.7rem" />
                    <Text
                      color="#AAAAAA"
                      fontSize="1rem"
                      maxW="250px"
                      textAlign="center"
                      marginTop="21px"
                    >
                      Parece que você não tem nenhum site criado
                    </Text>
                  </VStack>
                  <Flex>
                    <Link
                      // href="step-one"
                      bg="#FF5000"
                      p="13px 47px"
                      borderRadius="133.5px"
                      color="white"
                      fontSize="1rem"
                      m="0 !important"
                      width="100%"
                      textAlign="center"
                      h="fit-content"
                      onClick={() => {
                        handlePostWebsite();
                      }}
                    >
                      Criar novo site
                    </Link>
                  </Flex>
                </Grid>
              </Box>
              {hasNextPage && (
                <Box
                  as="div"
                  minH="500px"
                  w="350px"
                  h="1vh"
                  bg="white"
                  boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
                  borderRadius="24px"
                  p="28px 20px"
                >
                  <Grid gridTemplateRows="88% 12%" height="100%">
                    <VStack
                      alignItems="center"
                      justifyContent="center"
                      position="relative"
                    >
                      <DownwardArrowIcon
                        width="4rem"
                        height="3.8rem"
                        opacity="50%"
                      />
                      <Text
                        color="#AAAAAA"
                        fontSize="1rem"
                        maxW="250px"
                        textAlign="center"
                        marginTop="21px"
                      >
                        Você tem mais sites para visualizar
                      </Text>
                    </VStack>
                    <Flex>
                      <Link
                        // href="step-one"
                        bg="#FF5000"
                        p="13px 47px"
                        borderRadius="133.5px"
                        color="white"
                        fontSize="1rem"
                        m="0 !important"
                        width="100%"
                        textAlign="center"
                        h="fit-content"
                        onClick={() => {
                          setCurrentPage((currentPage) => currentPage + 1);
                          setHasNextPage(false);
                        }}
                      >
                        Carregar mais
                      </Link>
                    </Flex>
                  </Grid>
                </Box>
              )}
            </SimpleGrid>
          </Box>
        </GridItem>
      </Grid>
      <ModalConfirm
        content={
          typeAction.type === 'update'
            ? 'Tem certeza que deseja alterar esse Website?'
            : 'Tem certeza que deseja excluir esse Website?'
        }
        submit={
          typeAction.type === 'update'
            ? () => {
                handlePutWebsite(typeAction.id);
              }
            : () => {
                handleDeleteWebsite(typeAction.id);
              }
        }
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
};
